import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import omit from 'lodash/omit';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
var Alert = /*#__PURE__*/function (_Component) {
  function Alert() {
    var _this;
    _classCallCheck(this, Alert);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Alert, [].concat(args));
    _defineProperty(_this, "state", {
      alerts: {}
    });
    _defineProperty(_this, "_timeouts", []);
    _defineProperty(_this, "setAlert", function (content) {
      _this.setState({
        alerts: _objectSpread(_objectSpread({}, _this.state.alerts), {}, _defineProperty({}, content, content))
      });
      _this._timeouts = _this._timeouts.concat(setTimeout(function () {
        return _this.setState({
          alerts: omit(_this.state.alerts, [content])
        });
      }, 1000));
    });
    return _this;
  }
  _inherits(Alert, _Component);
  return _createClass(Alert, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._timeouts.forEach(clearTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var alerts = Object.values(this.state.alerts);
      return /*#__PURE__*/React.createElement(ScreenReaderContent, null, /*#__PURE__*/React.createElement("div", {
        role: "alert",
        "aria-live": "assertive"
      }, alerts.map(function (alert) {
        return /*#__PURE__*/React.createElement("span", {
          key: alert
        }, alert);
      })));
    }
  }]);
}(Component);
export { Alert as default };